const schema = require('./schema')
const listPage = require('./listPage')
const editPage = require('./editPage')

const config = {
  title: '進貨單',
  schema,
  list: listPage,
  edit: editPage,
}

module.exports = config
